// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rnhaD","rootMobile":"styles_rootMobile__1hkvU"};